// extracted by mini-css-extract-plugin
export default {"tabFocusDom":"TabFocusDom_tabFocusDom_EwhjA","fullwidth":"TabFocusDom_fullwidth_MFzz5","inline":"TabFocusDom_inline_sSETR"};